import { type DiagramPayload } from '@bizzdesign/modeler/models';
import { type ViewActionKey, viewActionKeys } from '@bizzdesign/shared/models';

// Utils related to type checks

//#region Freeformat
export const typesWithoutSemantics = ['Text'];
//#endregion

export const limitTo = (x: number, lower: number, upper: number): number => {
  if (x < lower) {
    return lower;
  }
  if (x > upper) {
    return upper;
  }
  return x;
};

export function assertIsDiagramPayload(
  value: unknown,
): asserts value is NonNullable<DiagramPayload> {
  if (value === undefined || value === null) {
    throw new Error(`Value is not defined`);
  }

  if (typeof value !== 'object') {
    let repr: string;
    try {
      repr = JSON.stringify(value);
    } catch {
      repr = String(value);
    }
    throw new TypeError(`${repr} is not an object-signature type`);
  }

  if (
    (value as any)['payload'] === undefined ||
    !Array.isArray((value as any)['fromRepoElements'])
  ) {
    throw new Error(`Value is not of type DiagramPayload`);
  }
}

export function assertIsViewActionKey(
  value: unknown,
): asserts value is ViewActionKey {
  if (!!!value) {
    throw new Error('Value is not defined');
  }
  if (typeof value !== 'string') {
    throw new TypeError('Value is not a string type');
  }
  if (!(viewActionKeys as readonly string[]).includes(value)) {
    throw new Error('Value is not a ViewActionKey');
  }
}

export const BDCORE_SUBMENU_DIMENSIONS = { width: '368px', height: '210px' };
